import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Spotlight"] */ "/vercel/path0/apps/web/src/components/Spotlight.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/Toast.tsx");
